document.addEventListener("DOMContentLoaded", function () {
    var swiper;

    function initSwiper() {
        var slides = document.querySelectorAll(".mypopupSwiper .swiper-slide");
        if (slides.length > 5 || window.innerWidth <= 991 && slides.length > 2 ) {
        if (!swiper) {
            swiper = new Swiper(".mypopupSwiper", {
                navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
                slidesPerView: 2.1,
                spaceBetween: 16,
                breakpoints: { 768: { slidesPerView: 5, spaceBetween: 16 } }
            });
        } else {
            swiper.update(); // Update if already initialized
        }
        }
    }

    var popupToggle = document.getElementById("promo-popup-toggal");
    var popupannouncementToggle = document.getElementById("promo-popup-announcement-toggal");
    var popupContent = document.getElementById("promo-popup-content");
    var productList = popupContent?.querySelector(".popup-content-slider");
    var overlay = document.querySelector(".overlay-background");
    var offerBtn = document.querySelector(".offer-btn");

    if (popupToggle) {
        popupToggle.addEventListener("click", function () {
            popupContent.classList.toggle("active");
            document.body.classList.toggle("promo-toggle-active");

            if (popupContent.classList.contains("active")) {
                setTimeout(() => {
                    productList.style.display = "block";
                    initSwiper(); // Initialize Swiper after it's visible
                }, 10);
            } else {
                productList.style.display = "none";
            }
        });
    }
    if (popupannouncementToggle) {
        popupannouncementToggle.addEventListener("click", function () {
            popupContent.classList.toggle("active");
            document.body.classList.toggle("promo-toggle-active");

            if (popupContent.classList.contains("active")) {
                setTimeout(() => {
                    productList.style.display = "block";
                    initSwiper(); // Initialize Swiper after it's visible
                }, 10);
            } else {
                productList.style.display = "none";
            }
        });
    }

    document.addEventListener("click", function (event) {
        if (!popupContent.contains(event.target) && !popupToggle.contains(event.target) && !popupannouncementToggle.contains(event.target)) {
            popupContent.classList.remove("active");
            document.body.classList.remove("promo-toggle-active");
            productList.style.display = "none";
        }
    });

    if (overlay) {
        overlay.addEventListener("click", function () {
            popupContent.classList.remove("active");
            document.body.classList.remove("promo-toggle-active");
            productList.style.display = "none";
        });
    }
});

// document.addEventListener("DOMContentLoaded", function () {
//     var swiper = new Swiper(".featured-logo-wrapper", {
//       slidesPerView: 2,
//       spaceBetween: 0,
//       loop: true,  // Enables infinite scrolling
//       autoplay: {
//         delay: 3000, // Auto-slide every 3 seconds
//         disableOnInteraction: false, // Keep autoplay even after user interaction
//       },
//       breakpoints: { 
//         375: {
//           slidesPerView: 2,
//         },
//         767: {
//           slidesPerView: 3,
//         },
//         1024: {
//           slidesPerView: 4,
//         },
//         1199: {
//           slidesPerView: 6,
//         }
//       }
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
  const utilitySlider = document.querySelector('#store-messages');
  if (utilitySlider) {
    if (window.innerWidth <= 767) {
      new Swiper(utilitySlider, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        }
      });
    }
  }
});

// ingredient glossary filter script
  let ingredientContent = document.querySelectorAll('.filter-card');
  let ingredientMainWrapper = document.querySelector('#filterContent');
  ingredientContent.forEach(ele => {
    ingredientMainWrapper.appendChild(ele);
  });
  
  let filterTrigger = document.querySelectorAll('.ingredient-glossary-filter-section .filter-group li span');
  let fillterCards = document.querySelectorAll(`#filterContent [data-category]`);
  filterTrigger.forEach(btn => {
    btn.addEventListener('click', (e) => {
      
      filterTrigger.forEach(btns => {
        btns.classList.remove('active');
      });
      e.target.classList.add('active');
      
      let fillterCardsAttr = e.target.getAttribute('data-filter');
      fillterCards.forEach(card => {
        let cardAttr = card.getAttribute('data-category');
        if (cardAttr == fillterCardsAttr) {
          card.classList.add('visible');
        }else{
          card.classList.remove('visible');
        }
      });
    })
  });
// ingredient glossary filter script

// Footer collapsible menu in mobile
document.addEventListener("DOMContentLoaded", function () {
  function toggleMobileMenu() {
    if (window.innerWidth <= 749) {
      const collapsibleHeadings = document.querySelectorAll(".mobile-collaps-trigger");

      collapsibleHeadings.forEach((heading) => {
        const menu = heading.nextElementSibling;
        let caretIcon = heading.querySelector(".caret-icon");

        if (!caretIcon) {
          caretIcon = document.createElement("span");
          caretIcon.classList.add("caret-icon");
          heading.appendChild(caretIcon);
        }

        if (!menu.style.height) {
          menu.style.height = "0px"; // Ensure initial height is 0 for collapsed state
        }

        heading.addEventListener("click", function () {
          if (menu.classList.contains("active")) {
            // Close menu
            menu.style.height = menu.scrollHeight + "px"; // Fix height before collapsing
            setTimeout(() => (menu.style.height = "0px"), 10);
          } else {
            // Open menu
            menu.style.height = menu.scrollHeight + "px";
            setTimeout(() => (menu.style.height = "auto"), 300);
          }

          menu.classList.toggle("active");
          heading.classList.toggle("active");
          caretIcon.classList.toggle("open");
        });
      });
    }
  }

  toggleMobileMenu();
});


//Footer collaps menu in mobile device,

//open mega menu on hover 
document.querySelectorAll('header-menu').forEach(menu => {
    menu.querySelectorAll('details').forEach(detail => {
        const summary = detail.querySelector('summary');

        // Open details on hover
        summary.addEventListener('mouseenter', () => {
            detail.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
        });

        // Close details when the mouse leaves the menu
        detail.addEventListener('mouseleave', () => {
            detail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.accordion__content.rte').forEach(container => {
    container.querySelectorAll("a").forEach(anchor => {
      if (!anchor.hasAttribute("href")) {
        let parts = [];

        // Collect attribute names and values
        for (let attr of anchor.attributes) {
          if (attr.name !== "class" && attr.name !== "style") {
            if (attr.name.startsWith("http")) {
              parts.push(attr.name);
            } else if (attr.name !== "href") {
              parts.push(attr.name);
            }
            if (attr.value && !attr.value.includes('""')) {
              parts.push(attr.value);
            }
          }
        }

        // Join parts and ensure slashes between segments
        let href = parts.join("/").replace(/\/+/g, "/"); // collapse multiple slashes
        href = href.replace(/^https:\//, "https://"); // fix double slash at the start
        if (href.startsWith("http")) {
          anchor.setAttribute("href", href);
        }
      }
    });
  });
});